import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
/**
 * 定义 Pagination 组件
 */
class Pagination extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            start: 1,
            current: 1,
        };
        this.handlePageItemClick = (index, end) => {
            const { handleClick } = this.props;
            let start = 1;
            handleClick(index);
            // 处理当前页标签所处分页器中位置
            if (end > 10 && index > 5) {
                const fakeEnd = index + 4;
                if (fakeEnd <= end) {
                    start = index - 5;
                }
                else {
                    start = end - 9;
                }
            }
            this.setState({
                start,
                current: index,
            });
        };
        this.handleArrowClick = (canClick, action, end) => {
            if (canClick) {
                const { current } = this.state;
                this.handlePageItemClick(action === 'pre' ? current - 1 : current + 1, end);
            }
        };
        this.renderPageItem = (start, end) => {
            let pagesItem = [];
            const { current } = this.state;
            for (let i = start; i <= end && pagesItem.length < 10; i++) {
                pagesItem.push(i === current ? (React.createElement("span", { key: i, className: styles.curPage }, i)) : (React.createElement("a", { href: "javascript:void(0);", key: i, className: styles.pageNum, onClick: () => this.handlePageItemClick(i, end) }, i)));
            }
            return pagesItem;
        };
        this.renderPageFlipper = (total, pageSize) => {
            const { start, current } = this.state;
            const pagesNum = Math.ceil(total / pageSize);
            if (pagesNum) {
                return (React.createElement(Fragment, null,
                    React.createElement("a", { href: "javascript:void(0);", className: current === 1 ? styles.cantClick : '', onClick: () => this.handleArrowClick(current !== 1, 'pre', pagesNum) }, "<"),
                    this.renderPageItem(start, pagesNum),
                    React.createElement("a", { href: "javascript:void(0);", className: current === pagesNum ? styles.cantClick : '', onClick: () => this.handleArrowClick(current !== pagesNum, 'next', pagesNum) }, ">")));
            }
            return null;
        };
    }
    /**
     * 渲染组件
     */
    render() {
        const { total, pageSize = 10 } = this.props;
        return React.createElement("div", { className: styles.paginationBox }, this.renderPageFlipper(total, pageSize));
    }
}
Pagination.propTypes = {
    total: PropTypes.number,
    pageSize: PropTypes.number,
    handleClick: PropTypes.func,
};
export default Pagination;
